import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  HStack,
  Spinner,
  Stack,
  Tbody,
  Td,
  Tr,
} from '@chakra-ui/react';
import React, { useState } from 'react';
import { Text } from '@chakra-ui/layout';
import { useHistory } from 'react-router-dom';
import { ContractView } from '~/types';
import { Card } from '~/components/Card';
import { StatusBadge, Table } from '~/components';
import { getDetalheContratoParqueMaquinas } from '~/hooks/useStrategicMap';
import { MachineParkContractDetailView } from '~/types/strategicMap';
import { capitalizeFirstLetter } from '~/utils/formatString';
import { ContractCharts } from '~/pages/Portal/StrategicMap/ContractCharts';

export const StrategicMapContracts: React.VFC<{
  contrato: ContractView;
}> = ({ contrato }) => {
  const [detalheContrato, setDetalheContrato] =
    useState<MachineParkContractDetailView | null>(null);
  const [loading, setLoading] = useState(false);

  const history = useHistory();

  const carregarDetalheContrato = async () => {
    setLoading(true);
    getDetalheContratoParqueMaquinas(Number(contrato.id_contrato))
      .then(response => {
        setDetalheContrato(response);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const estiloInfoGerais = (label: string, valor: string) => (
    <Tr border="none" lineHeight="1.2rem">
      <Td
        border="none"
        fontWeight="bold"
        fontSize="14px !important"
        pt="5px !important"
        pb="5px !important"
      >
        {label}
      </Td>
      <Td
        pt="5px !important"
        pb="5px !important"
        border="none"
        fontSize="14px !important"
        style={{ textAlign: 'left' }}
      >
        {valor}
      </Td>
    </Tr>
  );

  const irParaDetalheContrato = (e: React.MouseEvent) => {
    e.stopPropagation();
    history.push(`/portal/contracts/${contrato.id_contrato}`);
  };

  return (
    <Accordion allowMultiple>
      <AccordionItem
        id={contrato.id_contrato}
        borderRadius="8px"
        borderWidth="1px"
      >
        <h2>
          <AccordionButton
            px={2}
            py={4}
            backgroundColor="#FAFAFA"
            borderBottomWidth="1px"
            onClick={carregarDetalheContrato}
            justifyContent="space-between"
          >
            <HStack>
              <Text fontWeight="bold">N° Contrato: </Text>
              <Text
                textDecoration="underline"
                fontWeight="bold"
                cursor="pointer"
                ml={1}
                onClick={irParaDetalheContrato}
              >
                {contrato.nu_contrato}
              </Text>
            </HStack>
            <AccordionIcon boxSize="20px" />{' '}
          </AccordionButton>
        </h2>
        <AccordionPanel p={2}>
          {!!detalheContrato && !loading ? (
            <HStack
              width="100%"
              height="100%"
              flexWrap="wrap"
              justifyContent="start"
              alignItems="baseline"
              gridGap={2}
            >
              <Stack width="25%" marginStart="0 !important" height="100%">
                <Card
                  minW="fit-content"
                  height="100%"
                  bg="transparent"
                  header={<Text fontWeight="bold">Informações gerais</Text>}
                  content={
                    <Table type="primary" p={0}>
                      <Tbody border="none">
                        <Tr border="none">
                          <Td
                            border="none"
                            fontWeight="bold"
                            fontSize="14px !important"
                            pt="5px !important"
                            pb="5px !important"
                          >
                            Status de pagamento:
                          </Td>
                          <Td
                            pt="5px !important"
                            pb="5px !important"
                            border="none"
                            fontSize="14px !important"
                            style={{ textAlign: 'left' }}
                          >
                            <StatusBadge
                              variant={detalheContrato?.colorScheme || ''}
                            >
                              {detalheContrato?.status_pgto}
                            </StatusBadge>
                          </Td>
                        </Tr>
                        {estiloInfoGerais(
                          'Termo de Contrato:',
                          detalheContrato?.nu_pedido,
                        )}
                        {estiloInfoGerais(
                          'Prazo de locação:',
                          detalheContrato?.prazo_contrato || '-',
                        )}
                        {estiloInfoGerais(
                          'Data início da cobrança:',
                          capitalizeFirstLetter(
                            detalheContrato?.formattedInitialDate,
                          ),
                        )}
                        {estiloInfoGerais(
                          'Data de encerramento:',
                          capitalizeFirstLetter(
                            detalheContrato?.formattedEndDate,
                          ),
                        )}
                        {estiloInfoGerais(
                          'Extensão:',
                          detalheContrato?.qtd_extensoes.toString(),
                        )}
                        {estiloInfoGerais(
                          'Faturas em aberto:',
                          detalheContrato?.qtd_faturas_em_aberto.toString(),
                        )}
                        {estiloInfoGerais(
                          'Valor mensal:',
                          detalheContrato?.formattedMensalValue,
                        )}
                        {estiloInfoGerais(
                          'Mês de reajuste:',
                          capitalizeFirstLetter(
                            detalheContrato?.formattedMonth,
                          ),
                        )}
                        {estiloInfoGerais(
                          'Índice de correção:',
                          detalheContrato?.nm_indicecorrecao || '-',
                        )}
                        {estiloInfoGerais(
                          'Valor pago até o momento:',
                          detalheContrato?.formattedVrPagoAteMomento,
                        )}
                        {estiloInfoGerais(
                          'Valor pendente de pagamento:',
                          detalheContrato?.formattedVrPendentePagamento,
                        )}
                      </Tbody>
                    </Table>
                  }
                />
              </Stack>
              <ContractCharts
                contrato={detalheContrato}
                data_key={`strategic_map_${detalheContrato.id_contrato}`}
              />
            </HStack>
          ) : loading ? (
            <Spinner />
          ) : (
            <Text>Não há dados.</Text>
          )}
        </AccordionPanel>
      </AccordionItem>
    </Accordion>
  );
};
